var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResourcesGraduateIcon = function SvgResourcesGraduateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 84,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF0EB",
    strokeLinejoin: "bevel",
    strokeWidth: 20,
    d: "M95.923 29 5.667 10l90.256 49L5.667 74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF6D34",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "m77.583 33.925-26.916 16.15-26.917-16.15 26.917-16.15zM69.508 38.827v13.94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF6D34",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M69.508 52.767v2.691c0 5.95-8.5 10.767-18.841 10.767s-18.842-4.817-18.842-10.767V38.827M50.667 33.925l10.766 10.767M61.433 55.458V44.692"
  })));
};
export default SvgResourcesGraduateIcon;